import $ from "jquery";

/*
 * ClickableCard
 * Allow for click of an entire promo without harming the accessible reading of said card.
 */
export class ClickableCard {
  constructor($el) {
    this.$el = $el;
    this.href = this.$el.data("href");

    this.$el.addClass("is-clickable");

    this.bindEvents();
  }

  bindEvents() {
    let thisCard = this;

    thisCard.$el.on("click", "a", function(e) {
      e.stopPropagation();
    });

    thisCard.$el.on("click", function() {
      window.location.href = thisCard.href;
    });
  }
}
